import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get city data
import { getTags } from 'models/tags'; // Importing function to get tag data
import { getPositions } from 'models/positions'; // Importing function to get position data
import 'webix/photo'; // Importing photo module from webix
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { persons } from '../../../models/persons'; // Importing persons model
import { devConfig } from '../../../config/config'; // Importing development configuration

export default class InformationView extends JetView {
    // Defining InformationView class extending JetView
    config() {
        // Method to define the view configuration
        const _ = this.app.getService('locale')._; // Getting localization service
        const screen = this.app.config.size; // Getting screen size configuration
        const main_info = {
            // Main information layout configuration
            margin: 20,
            minWidth: 200,
            cols: [
                {
                    margin: 10,
                    rows: [
                        {
                            view: 'text', // Text input for Total Deposits
                            name: 'TotalDeposit',
                            label: _('Total Depósitos'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Depósitos'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Sports Stakes
                            name: 'TotalSportStakes',
                            label: _('Total Apuestas Deportivas'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Apuestas Deportivas'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Sports Winnings
                            name: 'TotalSportWinnings',
                            label: _('Total Ganancias Deportivas'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Ganancias Deportivas'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Casino Stakes
                            name: 'TotalCasinoStakes',
                            label: _('Total Apuestas Casino'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Apuestas Casino'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Casino Winnings
                            name: 'TotalCasinoWinnings',
                            label: _('Ganancias Totales Casino'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Ganancias Totales Casino'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Withdrawals
                            name: 'TotalWithdrawal',
                            label: _('Total Retiros'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Retiros'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Adjustments Entry
                            name: 'AdjustmentE',
                            label: _('Total Ajustes Entrada'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Ajustes Entrada'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Total Adjustments Exit
                            name: 'AdjustmentS',
                            label: _('Total Ajustes Salida'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Total Ajustes Salida'), // Localized placeholder
                            disabled: true, // Input is disabled
                        },
                    ],
                },
            ],
        };
        const more_info = {
            // Additional information layout configuration
            margin: 20,
            minWidth: 200,
            cols: [
                {
                    margin: 10,
                    rows: [
                        {
                            view: 'template', // Template view for loading indicator
                            id: 'templateResume',
                            template:
                                "<div class='container-preload' style=\" position: absolute; left: 0px; top: 0px; background: #ffffffba; \"><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 75px);width: 150px;' class='progress'><div class='icon-doradobet'></div></div></div>",
                        },
                    ],
                },
            ],
        };
        const left_main = {
            // Left main layout configuration
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Including main_info in rows
        };
        const upper_section = {
            // Upper section layout configuration
            id: 'a1',
            scroll: true,
            height: 950,
            rows: [
                {
                    margin: 30,
                    responsive: 'a1',
                    cols: [main_info, more_info], // Including main_info and more_info in columns
                },
            ],
        };
        const upper_section_narrow = {
            // Narrow upper section layout configuration
            cols: [
                {
                    id: 'financial',
                    margin: 10,
                    rows: [
                        main_info, // Including main_info in rows
                    ],
                },
            ],
        };
        webix.ui.fullScreen(); // Setting the UI to full screen mode
        return {
            view: 'form', // Returning form view
            rows: [upper_section], // Including upper_section in rows
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fname
            },
        };
    }
    init(form) {
        // Initialization method for the view
        this.on(this.app, 'customer:updateFinance', (id) => {
            // Event listener for updating finance
            const test = this; // Reference to the current instance
            webix
                .ajax() // AJAX request to fetch client KPI
                .get(devConfig.geturlApi() + 'Client/GetClientKpi', 'id=' + id, {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handling
                        webix.message('Error! '); // Displaying error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handling
                        text = JSON.parse(text); // Parsing response text
                        var shtml = // HTML string for displaying summary
                            '<div style=" width: 100%; "> <h2> Resumen </h2> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Depositos: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalDeposit) + // Formatting total deposit
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Apuestas en Deportivas: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalSportStakes, // Formatting total sports stakes
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Apuestas en Casino: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalCasinoStakes, // Formatting total casino stakes
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Total Apuestas: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalCasinoStakes + text[0].TotalSportStakes, // Formatting total bets
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Premios en Deportivas: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalSportWinnings, // Formatting total sports winnings
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Premios en Casino: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalCasinoWinnings, // Formatting total casino winnings
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Total Premios: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalSportWinnings + text[0].TotalCasinoWinnings, // Formatting total winnings
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Notas pendientes: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalPendingWithdrawal, // Formatting total pending withdrawals
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Valor Retirado: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                text[0].TotalWithdrawal, // Formatting total withdrawals
                            ) +
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Bonos: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].TotalBonus) + // Formatting total bonuses
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Ajustes Entrada: </div><div style=" display: inline-block; font-weight: bold; color: green; float: right; ">(+)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].AdjustmentE) + // Formatting total adjustments entry
                            '</div>  </div>' +
                            '<div style=" width: 100%; padding: 5px 0px;"> <div style=" display: inline-block; ">Ajustes Salida: </div><div style=" display: inline-block; font-weight: bold; color: red; float: right; ">(-)</div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(text[0].AdjustmentS) + // Formatting total adjustments exit
                            '</div>  </div>' +
                            '<div style=" width: 100%; border-bottom: 1px dotted; padding: 5px 0px; "> </div> ' +
                            '<div style=" width: 100%; padding: 5px 0px;font-weight: bold;"> <div style=" display: inline-block; ">Total: </div><div style=" float:right;display: inline-block; padding-left: 5px;padding-right: 3px; font-weight: bold; ">' +
                            webix.i18n.priceFormat(
                                (
                                    text[0].TotalDeposit -
                                    text[0].TotalSportStakes -
                                    text[0].TotalCasinoStakes +
                                    text[0].TotalSportWinnings +
                                    text[0].TotalCasinoWinnings -
                                    text[0].TotalPendingWithdrawal -
                                    text[0].TotalWithdrawal +
                                    text[0].TotalBonus +
                                    text[0].AdjustmentE -
                                    text[0].AdjustmentS
                                ).toFixed(2), // Calculating total
                                { decimalSize: 2 },
                            ) +
                            '</div>  </div>' +
                            '</div>';
                        $$('templateResume').setHTML(shtml); // Setting the HTML content of the template
                        test.app.callEvent('customer:updatedataFinance', [
                            text[0], // Triggering event to update finance data
                        ]);
                    },
                });
        });
        this.app.callEvent('customer:updateFinance', [
            // Triggering finance update event
            this.getParam('user', true), // Getting user parameter
        ]);
        this.on(
            this.app,
            'customer:updatedataFinance',
            (
                person, // Event listener for updating form values
            ) => form.setValues(person),
        );
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event listener for person selection
    }
    getLocalizedComboOptions() {
        // Method to get localized options for combo boxes
        const _ = this.app.getService('locale')._; // Getting localization service
        let p_options = webix.copy(getPositions()); // Copying position options
        p_options.map((x) => (x.value = _(x.value))); // Localizing position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Parsing position options into combo
        let t_options = webix.copy(getTags()); // Copying tag options
        t_options.map((x) => (x.value = _(x.value))); // Localizing tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Parsing tag options into combo
        let c_options = webix.copy(getCities()); // Copying city options
        c_options.map((x) => (x.value = _(x.value))); // Localizing city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Parsing city options into combo
    }
}

// FILE DOCUMENTED
